/**
 * Created by liubo on 16/3/28.
 */
export default function getBSGlobal(name) {
    return BSGlobal && BSGlobal[name];
}